import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import BrowserPersistence from "@magento/peregrine/lib/util/simplePersistence";
import { closeDrawer } from "@magento/peregrine/lib/store/actions/app";
import actions from "./actions";
var storage = new BrowserPersistence();
export var beginCheckout = () => ( /*#__PURE__*/function () {
  var _thunk = _asyncToGenerator(function* (dispatch) {
    // Before we begin, reset the state of checkout to clear out stale data.
    dispatch(actions.reset());
    var storedAvailableShippingMethods = yield retreiveAvailableShippingMethods();
    var storedBillingAddress = yield retrieveBillingAddress();
    var storedPaymentMethod = yield retrievePaymentMethod();
    var storedShippingAddress = yield retrieveShippingAddress();
    var storedShippingMethod = yield retrieveShippingMethod();
    dispatch(actions.begin({
      availableShippingMethods: storedAvailableShippingMethods || [],
      billingAddress: storedBillingAddress,
      paymentCode: storedPaymentMethod && storedPaymentMethod.code,
      paymentData: storedPaymentMethod && storedPaymentMethod.data,
      shippingAddress: storedShippingAddress || {},
      shippingMethod: storedShippingMethod && storedShippingMethod.carrier_code,
      shippingTitle: storedShippingMethod && storedShippingMethod.carrier_title
    }));
  });
  function thunk(_x) {
    return _thunk.apply(this, arguments);
  }
  return thunk;
}());
export var cancelCheckout = () => ( /*#__PURE__*/function () {
  var _thunk2 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.reset());
  });
  function thunk(_x2) {
    return _thunk2.apply(this, arguments);
  }
  return thunk;
}());
export var resetCheckout = () => ( /*#__PURE__*/function () {
  var _thunk3 = _asyncToGenerator(function* (dispatch) {
    yield dispatch(closeDrawer());
    dispatch(actions.reset());
  });
  function thunk(_x3) {
    return _thunk3.apply(this, arguments);
  }
  return thunk;
}());
export var resetReceipt = () => ( /*#__PURE__*/function () {
  var _thunk4 = _asyncToGenerator(function* (dispatch) {
    yield dispatch(actions.receipt.reset());
  });
  function thunk(_x4) {
    return _thunk4.apply(this, arguments);
  }
  return thunk;
}());
export var submitPaymentMethodAndBillingAddress = payload => ( /*#__PURE__*/function () {
  var _thunk5 = _asyncToGenerator(function* (dispatch) {
    var {
      countries,
      formValues
    } = payload;
    var {
      billingAddress,
      paymentMethod
    } = formValues;
    return Promise.all([dispatch(submitBillingAddress({
      billingAddress,
      countries
    })), dispatch(submitPaymentMethod(paymentMethod))]);
  });
  function thunk(_x5) {
    return _thunk5.apply(this, arguments);
  }
  return thunk;
}());
export var submitBillingAddress = payload => ( /*#__PURE__*/function () {
  var _thunk6 = _asyncToGenerator(function* (dispatch, getState) {
    dispatch(actions.billingAddress.submit());
    var {
      cart
    } = getState();
    var {
      cartId
    } = cart;
    if (!cartId) {
      throw new Error("Missing required information: cartId");
    }
    try {
      var {
        billingAddress,
        countries
      } = payload;
      var desiredBillingAddress = billingAddress;
      if (!billingAddress.sameAsShippingAddress) {
        desiredBillingAddress = formatAddress(billingAddress, countries);
      }
      yield saveBillingAddress(desiredBillingAddress);
      dispatch(actions.billingAddress.accept(desiredBillingAddress));
    } catch (error) {
      dispatch(actions.billingAddress.reject(error));
      throw error;
    }
  });
  function thunk(_x6, _x7) {
    return _thunk6.apply(this, arguments);
  }
  return thunk;
}());
export var submitPaymentMethod = payload => ( /*#__PURE__*/function () {
  var _thunk7 = _asyncToGenerator(function* (dispatch, getState) {
    dispatch(actions.paymentMethod.submit(payload));
  });
  function thunk(_x8, _x9) {
    return _thunk7.apply(this, arguments);
  }
  return thunk;
}());
export var submitPaymentMethodComponentSelected = payload => ( /*#__PURE__*/function () {
  var _thunk8 = _asyncToGenerator(function* (dispatch, getState) {
    dispatch(actions.paymentMethodComponentSelected.submit(payload));
  });
  function thunk(_x10, _x11) {
    return _thunk8.apply(this, arguments);
  }
  return thunk;
}());
export var submitAvailablePaymentMethods = payload => ( /*#__PURE__*/function () {
  var _thunk9 = _asyncToGenerator(function* (dispatch, getState) {
    dispatch(actions.availablePaymentMethods.submit(payload));
  });
  function thunk(_x12, _x13) {
    return _thunk9.apply(this, arguments);
  }
  return thunk;
}());
export var submitShippingAddress = function () {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _thunk10 = _asyncToGenerator(function* (dispatch, getState) {
      dispatch(actions.shippingAddress.submit());
      var {
        formValues,
        countries,
        setGuestEmail,
        setShippingAddressOnCart
      } = payload;
      var {
        cart,
        user
      } = getState();
      var {
        cartId
      } = cart;
      if (!cartId) {
        throw new Error("Missing required information: cartId");
      }
      try {
        var address = formatAddress(formValues, countries);
        if (!user.isSignedIn) {
          if (!formValues.email) {
            throw new Error("Missing required information: email");
          }
          yield setGuestEmail({
            variables: {
              cartId,
              email: formValues.email
            }
          });
        }
        var {
          firstname,
          lastname,
          street,
          city,
          region_code,
          postcode,
          telephone,
          country_id
        } = address;
        var {
          data
        } = yield setShippingAddressOnCart({
          variables: {
            cartId,
            firstname,
            lastname,
            street,
            city,
            region_code,
            postcode,
            telephone,
            country_id
          }
        });
        // We can get the shipping methods immediately after setting the
        // address. Grab it from the response and put it in the store.
        var shippingMethods = data.setShippingAddressesOnCart.cart.shipping_addresses[0].available_shipping_methods;

        // On success, save to local storage.
        yield saveAvailableShippingMethods(shippingMethods);
        yield saveShippingAddress(address);
        dispatch(actions.getShippingMethods.receive(shippingMethods));
        dispatch(actions.shippingAddress.accept(address));
      } catch (error) {
        dispatch(actions.shippingAddress.reject(error));
        throw error;
      }
    });
    function thunk(_x14, _x15) {
      return _thunk10.apply(this, arguments);
    }
    return thunk;
  }();
};
export var submitShippingMethod = payload => ( /*#__PURE__*/function () {
  var _thunk11 = _asyncToGenerator(function* (dispatch, getState) {
    dispatch(actions.shippingMethod.submit());
    var {
      cart
    } = getState();
    var {
      cartId
    } = cart;
    if (!cartId) {
      throw new Error("Missing required information: cartId");
    }
    try {
      var desiredShippingMethod = payload.formValues.shippingMethod;
      yield saveShippingMethod(desiredShippingMethod);
      dispatch(actions.shippingMethod.accept(desiredShippingMethod));
    } catch (error) {
      dispatch(actions.shippingMethod.reject(error));
      throw error;
    }
  });
  function thunk(_x16, _x17) {
    return _thunk11.apply(this, arguments);
  }
  return thunk;
}());
export var submitOrder = payload => ( /*#__PURE__*/function () {
  var _thunk12 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.receipt.setOrder(payload));
  });
  function thunk(_x18) {
    return _thunk12.apply(this, arguments);
  }
  return thunk;
}());
export var createAccount = _ref => {
  var {
    history
  } = _ref;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (dispatch, getState) {
      var {
        checkout
      } = getState();
      var {
        email,
        firstname: firstName,
        lastname: lastName
      } = checkout.receipt.order.shipping_address;
      var accountInfo = {
        email,
        firstName,
        lastName
      };

      // Once we grab what we need from checkout state we can reset.
      yield dispatch(resetCheckout());
      history.push("/create-account?".concat(new URLSearchParams(accountInfo)));
    });
    return function (_x19, _x20) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var submitPickupPointAvailability = payload => ( /*#__PURE__*/function () {
  var _thunk13 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.pickupPointAvailability.submit(payload));
  });
  function thunk(_x21) {
    return _thunk13.apply(this, arguments);
  }
  return thunk;
}());
export var submitAdyenConfig = payload => ( /*#__PURE__*/function () {
  var _thunk14 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.adyenConfig.submit(payload));
  });
  function thunk(_x22) {
    return _thunk14.apply(this, arguments);
  }
  return thunk;
}());
export var submitAdyenCheckout = payload => ( /*#__PURE__*/function () {
  var _thunk15 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.adyenCheckout.submit(payload));
  });
  function thunk(_x23) {
    return _thunk15.apply(this, arguments);
  }
  return thunk;
}());
export var submitAdyenState = payload => ( /*#__PURE__*/function () {
  var _thunk16 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.adyenState.submit(payload));
  });
  function thunk(_x24) {
    return _thunk16.apply(this, arguments);
  }
  return thunk;
}());
export var submitAdyenAdditionalDetails = payload => ( /*#__PURE__*/function () {
  var _thunk17 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.adyenAdditionalDetails.submit(payload));
  });
  function thunk(_x25) {
    return _thunk17.apply(this, arguments);
  }
  return thunk;
}());
export var submitCheckoutStepCompleted = payload => ( /*#__PURE__*/function () {
  var _thunk18 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.checkoutStepCompleted.submit(payload));
  });
  function thunk(_x26) {
    return _thunk18.apply(this, arguments);
  }
  return thunk;
}());
export var submitTableData = payload => ( /*#__PURE__*/function () {
  var _thunk19 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.tableData.submit(payload));
  });
  function thunk(_x27) {
    return _thunk19.apply(this, arguments);
  }
  return thunk;
}());
export var submitPickupTime = payload => ( /*#__PURE__*/function () {
  var _thunk20 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.pickupTime.submit(payload));
  });
  function thunk(_x28) {
    return _thunk20.apply(this, arguments);
  }
  return thunk;
}());
export var submitStoredShippingData = payload => ( /*#__PURE__*/function () {
  var _thunk21 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.storedShippingData.submit(payload));
  });
  function thunk(_x29) {
    return _thunk21.apply(this, arguments);
  }
  return thunk;
}());
export var submitCoverSKU = payload => ( /*#__PURE__*/function () {
  var _thunk22 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.coverSku.submit(payload));
  });
  function thunk(_x30) {
    return _thunk22.apply(this, arguments);
  }
  return thunk;
}());
export var submitHospitalityData = payload => ( /*#__PURE__*/function () {
  var _thunk23 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.hospitalityData.submit(payload));
  });
  function thunk(_x31) {
    return _thunk23.apply(this, arguments);
  }
  return thunk;
}());
export var submitPayAtStoreSelected = payload => ( /*#__PURE__*/function () {
  var _thunk24 = _asyncToGenerator(function* (dispatch) {
    dispatch(actions.payAtStoreSelected.submit(payload));
  });
  function thunk(_x32) {
    return _thunk24.apply(this, arguments);
  }
  return thunk;
}());

/* helpers */

/**
 * Formats an address in the shape the REST API expects.
 * TODO: Can we remove this code once address submissions switch to GraphQL?
 *
 * This function may throw.
 *
 * @param {object} address - The input address.
 * @param {object[]} countries - The list of countries data.
 */
export var formatAddress = function () {
  var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var countries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var {
    region_code
  } = address;
  var usa = countries.find(_ref3 => {
    var {
      id
    } = _ref3;
    return id === "US";
  });
  var {
    available_regions: regions
  } = usa;
  var region = regions.find(_ref4 => {
    var {
      code
    } = _ref4;
    return code === region_code;
  });
  return _objectSpread({
    country_id: "US",
    region_id: region.id,
    region_code: region.code,
    region: region.name
  }, address);
};
function clearAvailableShippingMethods() {
  return _clearAvailableShippingMethods.apply(this, arguments);
}
function _clearAvailableShippingMethods() {
  _clearAvailableShippingMethods = _asyncToGenerator(function* () {
    return storage.removeItem("availableShippingMethods");
  });
  return _clearAvailableShippingMethods.apply(this, arguments);
}
function retreiveAvailableShippingMethods() {
  return _retreiveAvailableShippingMethods.apply(this, arguments);
}
function _retreiveAvailableShippingMethods() {
  _retreiveAvailableShippingMethods = _asyncToGenerator(function* () {
    return storage.getItem("availableShippingMethods");
  });
  return _retreiveAvailableShippingMethods.apply(this, arguments);
}
function saveAvailableShippingMethods(_x33) {
  return _saveAvailableShippingMethods.apply(this, arguments);
}
function _saveAvailableShippingMethods() {
  _saveAvailableShippingMethods = _asyncToGenerator(function* (methods) {
    return storage.setItem("availableShippingMethods", methods);
  });
  return _saveAvailableShippingMethods.apply(this, arguments);
}
function clearBillingAddress() {
  return _clearBillingAddress.apply(this, arguments);
}
function _clearBillingAddress() {
  _clearBillingAddress = _asyncToGenerator(function* () {
    return storage.removeItem("billing_address");
  });
  return _clearBillingAddress.apply(this, arguments);
}
function retrieveBillingAddress() {
  return _retrieveBillingAddress.apply(this, arguments);
}
function _retrieveBillingAddress() {
  _retrieveBillingAddress = _asyncToGenerator(function* () {
    return storage.getItem("billing_address");
  });
  return _retrieveBillingAddress.apply(this, arguments);
}
function saveBillingAddress(_x34) {
  return _saveBillingAddress.apply(this, arguments);
}
function _saveBillingAddress() {
  _saveBillingAddress = _asyncToGenerator(function* (address) {
    return storage.setItem("billing_address", address);
  });
  return _saveBillingAddress.apply(this, arguments);
}
function clearPaymentMethod() {
  return _clearPaymentMethod.apply(this, arguments);
}
function _clearPaymentMethod() {
  _clearPaymentMethod = _asyncToGenerator(function* () {
    return storage.removeItem("paymentMethod");
  });
  return _clearPaymentMethod.apply(this, arguments);
}
function retrievePaymentMethod() {
  return _retrievePaymentMethod.apply(this, arguments);
}
function _retrievePaymentMethod() {
  _retrievePaymentMethod = _asyncToGenerator(function* () {
    return storage.getItem("paymentMethod");
  });
  return _retrievePaymentMethod.apply(this, arguments);
}
function savePaymentMethod(_x35) {
  return _savePaymentMethod.apply(this, arguments);
}
function _savePaymentMethod() {
  _savePaymentMethod = _asyncToGenerator(function* (method) {
    return storage.setItem("paymentMethod", method);
  });
  return _savePaymentMethod.apply(this, arguments);
}
function clearShippingAddress() {
  return _clearShippingAddress.apply(this, arguments);
}
function _clearShippingAddress() {
  _clearShippingAddress = _asyncToGenerator(function* () {
    return storage.removeItem("shipping_address");
  });
  return _clearShippingAddress.apply(this, arguments);
}
function retrieveShippingAddress() {
  return _retrieveShippingAddress.apply(this, arguments);
}
function _retrieveShippingAddress() {
  _retrieveShippingAddress = _asyncToGenerator(function* () {
    return storage.getItem("shipping_address");
  });
  return _retrieveShippingAddress.apply(this, arguments);
}
function saveShippingAddress(_x36) {
  return _saveShippingAddress.apply(this, arguments);
}
function _saveShippingAddress() {
  _saveShippingAddress = _asyncToGenerator(function* (address) {
    return storage.setItem("shipping_address", address);
  });
  return _saveShippingAddress.apply(this, arguments);
}
function clearShippingMethod() {
  return _clearShippingMethod.apply(this, arguments);
}
function _clearShippingMethod() {
  _clearShippingMethod = _asyncToGenerator(function* () {
    return storage.removeItem("shippingMethod");
  });
  return _clearShippingMethod.apply(this, arguments);
}
function retrieveShippingMethod() {
  return _retrieveShippingMethod.apply(this, arguments);
}
function _retrieveShippingMethod() {
  _retrieveShippingMethod = _asyncToGenerator(function* () {
    return storage.getItem("shippingMethod");
  });
  return _retrieveShippingMethod.apply(this, arguments);
}
function saveShippingMethod(_x37) {
  return _saveShippingMethod.apply(this, arguments);
}
function _saveShippingMethod() {
  _saveShippingMethod = _asyncToGenerator(function* (method) {
    return storage.setItem("shippingMethod", method);
  });
  return _saveShippingMethod.apply(this, arguments);
}
export var clearCheckoutDataFromStorage = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(function* () {
    yield clearBillingAddress();
    yield clearPaymentMethod();
    yield clearShippingAddress();
    yield clearShippingMethod();
    yield clearAvailableShippingMethods();
  });
  return function clearCheckoutDataFromStorage() {
    return _ref5.apply(this, arguments);
  };
}();